const legacy = {
  specification: {
    'film-license': {
      title: 'Viddsee Film License Agreement',
      sequence: [
        'whatIsViddsee',
        'termsAndConditions',
        'nonExclusive',
        'filmmakerDetailsForm',
        'filmmakerFilmForm',
        'thirdParty',
        'monetisation',
        'agreement',
      ],
    },
    'lite': {
      title: 'Viddsee Film License Agreement',
      sequence: [
        'termsAndConditions',
      ],
    },
    'intro': {
      title: 'Viddsee Film License Agreement',
      sequence: [
        'termsAndConditions',
        'agreement',
      ],
    },
    'submission': {
      title: '',
      sequence: [
        'thirdParty',
        'monetisation',
      ],
    },
  },
  action: {
    filmmakerFilmForm: {
      id: 'filmmakerFilmForm',
      itemFormName: 'films',
      optional: false,
      items: [{
        itemType: 'component',
        itemAction: null,
        itemComponent: {
          componentName: 'app-your-film',
        },
        itemHTML: '',
      }],
    },
    filmmakerDetailsForm: {
      id: 'filmmakerDetailsForm',
      itemFormName: 'filmmakerDetails',
      optional: false,
      items: [{
        itemType: 'component',
        itemAction: null,
        itemComponent: {
          componentName: 'app-your-details',
        },
        itemHTML: '',
      }],
    },
  },
  itemFormName: {
    agreement: 'terms-and-conditions',
    monetisation: 'rights_advertising',
    thirdParty: 'rights_general',
  },
};


export default {
  makeCompatible(results) {
    results.forEach((result) => {
      result.forEach((item) => {
        if (item.path === 'specification') {
          item.data = legacy.specification;
        }

        if (item.path.split('.')[0] === 'action') {
          const actionName = item.path.split('.')[1];

          if (legacy.itemFormName[actionName]) {
            item.data.itemFormName = legacy.itemFormName[actionName];
          }
        }
      });

      if (result[0].path.split('.')[0] === 'action') {
        result.push(
          ...Object.keys(legacy.action)
            .map(actionName => ({
              path: `action.${actionName}`,
              data: legacy.action[actionName],
            }))
        );
      }
    });
    return results;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/agreement/legacySpecification.js